// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"Modal_modalBackdrop__7Ffh1","modalContent":"Modal_modalContent__xN6h+","okButton":"Modal_okButton__tkjAY"};